'use client';

import { twMerge } from '@shared/themes';
import { YourNumbers } from '../../YourNumbers/YourNumbers';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

type PurchaseDetailsYourNumbersProps = {
  className?: string;
};

/**
 * Renders the played numbers for the active participation.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsYourNumbers({ className }: PurchaseDetailsYourNumbersProps) {
  const { ticket, lotteryName, activeParticipation } = usePurchaseDetails();

  return (
    <YourNumbers
      lineInfo={ticket.lineInfo}
      lotteryName={lotteryName}
      participation={activeParticipation}
      options={ticket.options}
      className={twMerge('ll-container-inner', className)}
    />
  );
}

export { PurchaseDetailsYourNumbers };
